const Flag = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 7A2.5 2.5 0 0 1 8 4.5h10.15a1 1 0 0 1 .874 1.486l-1.547 2.786a1.5 1.5 0 0 0 0 1.457l1.547 2.785a1 1 0 0 1-.874 1.486H8A1.5 1.5 0 0 0 6.5 16v4a.5.5 0 0 1-1 0zm1 7a2.5 2.5 0 0 1 1.5-.5h10.15l-1.547-2.786a2.5 2.5 0 0 1 0-2.428L18.15 5.5H8A1.5 1.5 0 0 0 6.5 7z"
      clipRule="evenodd"
    />
  </>
)
export default Flag
